function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#252C32"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M14.64 33.237c-1.18.001-2.311-.467-3.146-1.3l-6.28-6.292c-.835-.834-1.305-1.966-1.305-3.146s.47-2.312 1.304-3.146L20.932 3.635c1.76-1.68 4.53-1.68 6.291 0l3.135 3.146c.835.834 1.304 1.966 1.304 3.146s-.47 2.311-1.304 3.146L17.786 25.645c-1.738 1.737-4.555 1.737-6.292 0-1.737-1.738-1.737-4.555 0-6.292L21.721 9.137l1.623 1.579-10.216 10.216c-.869.868-.869 2.277 0 3.145.869.87 2.277.87 3.146 0L28.79 11.494c.417-.417.652-.983.652-1.573s-.235-1.156-.652-1.573l-3.146-3.135c-.417-.417-.983-.652-1.573-.652s-1.156.235-1.573.652L6.78 20.932c-.418.417-.652.982-.652 1.572 0 .59.234 1.156.652 1.573l6.292 6.281c.417.417.982.652 1.572.652.59 0 1.156-.235 1.573-.652l13.34-13.34 1.567 1.557-13.34 13.34c-.83.841-1.962 1.317-3.145 1.322z",
  transform: "translate(-261 -2379) translate(261.714 2379.571)"
}))));

var SvgCopy = function SvgCopy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy.1aec30a5.svg";
export { ForwardRef as ReactComponent };